import { c } from "react/compiler-runtime";
import { useDataProvider } from "@effektify/data-provider";
import { mapLineChartProps } from "../../utils/cardProps.js";
import useDatasetToSeries from "../useDatasetToSeries.js";
import useReportTranslations from "../useReportTranslations.js";
const useLineChartProps = (config, data) => {
  const $ = c(6);
  const {
    translate
  } = useReportTranslations();
  const {
    noComparison
  } = useDataProvider();
  const {
    resolveSeriesData
  } = useDatasetToSeries();
  let t0;
  if ($[0] !== config || $[1] !== data || $[2] !== noComparison || $[3] !== resolveSeriesData || $[4] !== translate) {
    t0 = mapLineChartProps(config, data ?? {}, {
      translate,
      noComparison: !!noComparison,
      resolveSeriesData
    });
    $[0] = config;
    $[1] = data;
    $[2] = noComparison;
    $[3] = resolveSeriesData;
    $[4] = translate;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  return t0;
};
export { useLineChartProps as default };